import { render, staticRenderFns } from "./CnR.vue?vue&type=template&id=2d18fa8e&scoped=true"
import script from "./CnR.vue?vue&type=script&lang=js"
export * from "./CnR.vue?vue&type=script&lang=js"
import style0 from "./CnR.vue?vue&type=style&index=0&id=2d18fa8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18fa8e",
  null
  
)

export default component.exports